import type { CartItem } from "@babackapp/return-widget-components/types/shop-now";

export const CART_SESSION_KEY = (orderId: string) => `baback-shop-now-cart-${orderId}`;

export function saveCart(orderId: string, items: CartItem[], currency: string): void {
  try {
    sessionStorage.setItem(CART_SESSION_KEY(orderId), JSON.stringify({ items, currency }));
  } catch { /* ignore */ }
}

export function loadCart(orderId: string): { items: CartItem[]; currency: string } | null {
  try {
    const raw = sessionStorage.getItem(CART_SESSION_KEY(orderId));
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}
